import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="user-tracking"
export default class extends Controller {
  connect() {
    console.log("User Tracking...")
  }
}
